<template>
	<table class="top-countries">
		<thead>
			<tr>
				<th v-html="_translate('m.topcountries.header.rank')"></th>
				<th v-html="_translate('m.topcountries.header.country')"></th>
				<th v-html="_translate('m.topcountries.header.percent')"></th>
				<th v-html="_translate('m.topcountries.header.change')"></th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="(item, index) in data">
				<td v-html="getRowRank(item, index)"></td>
				<td v-html="getRowCountry(item)"></td>
				<td v-html="getRowPercentage(item)"></td>
				<td v-html="getRowChange(item)"></td>
			</tr>
		</tbody>
	</table>
</template>

<script>

	export default {

		props: {
			data: {
				type: Array,
				default: () => []
			}
		},

		methods: {

			getRowRank: function(item, index) {

                if(item.changeAmnt) {
                    var change = '<span class="top-countries__rank ' + item.change + '">' + (index+1) + '<span class="top-countries__changeAmnt">(' + item.changeAmnt + ')</span></span>';
                }else {
                    var change = '<span class="top-countries__rank ' + item.change + '">' + (index+1) + '</span>';
                }

                // return changeAmnt;
				return change;
			},

			getRowCountry: function(item) {
				return this._translate(item.country);
			},

			getRowPercentage: function(item) {
				return '<span>' + this.formatPercentage((item.total/100), 2, false) + '</span>';
			},

			getRowChange: function(item) {
				var change = '<span class="';
				    change += (Number(item.yoy) < 0 ) ? 'negative' : 'positive';
						change += '">' + this.formatPercentage((item.yoy/100), 0) + '</span>'
				return change;
			}

		}

	}

</script>

<style lang="scss">

	.top-countries {
		width: 100%;
		border-collapse: collapse;
		box-shadow: 0 2px 1rem rgba(0, 0, 0, .06), 0 0 .5rem rgba(0, 0, 0, .06);

		thead {
			th {
				border-left-color: rgba(0, 0, 0, .15);
				border-right-color: rgba(0, 0, 0, .15);
			}
		}

		tr:last-child {
			td {
				border-bottom: 0;
			}
		}

		td,th {
			text-align: center;
			border: 1px solid #ddd;
			text-transform: uppercase;
			font-weight: 400;
			@include typesize('tiny');
			&:first-child {
				border-left: 0;
			}
			&:last-child {
				border-right: 0;
			}
		}

		th {
			color: $white;
			background-color: $blue-dark;
			padding: 1rem;
			border-bottom: transparent;
			border-top: 0;
		}

		td {
			padding: .5rem;
		}

		.top-countries__rank {
			color: $blue-dark;
			position: relative;
            padding-right: 36px;

			&::after {
				position: absolute;
				right: 23px;
				top: 5px;
				width: 0;
				height: 0;
				border-style: solid;
			}

			&.up {
				&::after {
					content: '';
					border-width: 0 4px 6px 4px;
					border-color: transparent transparent $green transparent;
				}
			}

			&.down {
				color: $red;
				&::after {
					content: '';
					border-width: 6px 4px 0 4px;
					border-color: $red transparent transparent transparent;
				}
			}

		}

        &__changeAmnt {
            position: absolute;
            font-size: 10px;
            right: 0;
        }

		.positive {
			color: $blue-dark;
		}

		.negative {
			color: $red;
		}
	}


</style>